export const data1: any = {
  A0: 1,
  'A#0': 2,
  Bb0: 2,
  B0: 3,
  C1: 4,
  'C#1': 5,
  Db1: 5,
  D1: 6,
  'D#1': 7,
  Eb1: 7,
  E1: 8,
  F1: 9,
  'F#1': 10,
  Gb1: 10,
  G1: 11,
  'G#1': 12,
  Ab1: 12,
  A1: 13,
  'A#1': 14,
  Bb1: 14,
  B1: 15,
  C2: 16,
  'C#2': 17,
  Db2: 17,
  D2: 18,
  'D#2': 19,
  Eb2: 19,
  E2: 20,
  F2: 21,
  'F#2': 22,
  Gb2: 22,
  G2: 23,
  'G#2': 24,
  Ab2: 24,
  A2: 25,
  'A#2': 26,
  Bb2: 26,
  B2: 27,
  C3: 28,
  'C#3': 29,
  Db3: 29,
  D3: 30,
  'D#3': 31,
  Eb3: 31,
  E3: 32,
  F3: 33,
  'F#3': 34,
  Gb3: 34,
  G3: 35,
  'G#3': 36,
  Ab3: 36,
  A3: 37,
  'A#3': 38,
  Bb3: 38,
  B3: 39,
  C4: 40,
  'C#4': 41,
  Db4: 41,
  D4: 42,
  'D#4': 43,
  Eb4: 43,
  E4: 44,
  F4: 45,
  'F#4': 46,
  Gb4: 46,
  G4: 47,
  'G#4': 48,
  Ab4: 48,
  A4: 49,
  'A#4': 50,
  Bb4: 50,
  B4: 51,
  C5: 52,
  'C#5': 53,
  Db5: 53,
  D5: 54,
  'D#5': 55,
  Eb5: 55,
  E5: 56,
  F5: 57,
  'F#5': 58,
  Gb5: 58,
  G5: 59,
  'G#5': 60,
  Ab5: 60,
  A5: 61,
  'A#5': 62,
  Bb5: 62,
  B5: 63,
  C6: 64,
  'C#6': 65,
  Db6: 65,
  D6: 66,
  'D#6': 67,
  Eb6: 67,
  E6: 68,
  F6: 69,
  'F#6': 70,
  Gb6: 70,
  G6: 71,
  'G#6': 72,
  Ab6: 72,
  A6: 73,
  'A#6': 74,
  Bb6: 74,
  B6: 75,
  C7: 76,
  'C#7': 77,
  Db7: 77,
  D7: 78,
  'D#7': 79,
  Eb7: 79,
  E7: 80,
  F7: 81,
  'F#7': 82,
  Gb7: 82,
  G7: 83,
  'G#7': 84,
  Ab7: 84,
  A7: 85,
  'A#7': 86,
  Bb7: 86,
  B7: 87,
  C8: 88,
}

export const data: any = {
  G9: 127,
  'F#9/Gb9': 126,
  F9: 125,
  E9: 124,
  'D#9/Eb9': 123,
  D9: 122,
  'C#9/Db9': 121,
  C9: 120,
  B8: 119,
  'A#8/Bb8': 118,
  A8: 117,
  'G#8/Ab8': 116,
  G8: 115,
  'F#8/Gb8': 114,
  F8: 113,
  E8: 112,
  'D#8/Eb8': 111,
  D8: 110,
  'C#8/Db8': 109,
  C8: 108,
  B7: 107,
  'A#7/Bb7': 106,
  A7: 105,
  'G#7/Ab7': 104,
  G7: 103,
  'F#7/Gb7': 102,
  F7: 101,
  E7: 10,
  'D#7/Eb7': 99,
  D7: 98,
  'C#7/Db7': 97,
  C7: 96,
  B6: 95,
  'A#6/Bb6': 94,
  A6: 93,
  'G#6/Ab6': 92,
  G6: 91,
  'F#6/Gb6': 90,
  F6: 89,
  E6: 88,
  'D#6/Eb6': 87,
  D6: 86,
  'C#6/Db6': 85,
  C6: 84,
  B5: 83,
  'A#5/Bb5': 82,
  A5: 81,
  'G#5/Ab5': 80,
  G5: 79,
  'F#5/Gb5': 78,
  F5: 77,
  E5: 76,
  'D#5/Eb5': 75,
  D5: 74,
  'C#5/Db5': 73,
  C5: 72,
  B4: 71,
  'A#4/Bb4': 70,
  'A4 concert pitch': 69,
  'G#4/Ab4': 68,
  G4: 67,
  'F#4/Gb4': 66,
  F4: 65,
  E4: 64,
  'D#4/Eb4': 63,
  D4: 62,
  'C#4/Db4': 61,
  'C4 (middle C)': 60,
  B3: 59,
  'A#3/Bb3': 58,
  A3: 57,
  'G#3/Ab3': 56,
  G3: 55,
  'F#3/Gb3': 54,
  F3: 53,
  E3: 52,
  'D#3/Eb3': 51,
  D3: 50,
  'C#3/Db3': 49,
  C3: 48,
  B2: 47,
  'A#2/Bb2': 46,
  A2: 45,
  'G#2/Ab2': 44,
  G2: 43,
  'F#2/Gb2': 42,
  F2: 41,
  E2: 40,
  'D#2/Eb2': 39,
  D2: 38,
  'C#2/Db2': 37,
  C2: 36,
  B1: 35,
  'A#1/Bb1': 34,
  A1: 33,
  'G#1/Ab1': 32,
  G1: 31,
  'F#1/Gb1': 30,
  F1: 29,
  E1: 28,
  'D#1/Eb1': 27,
  D1: 26,
  'C#1/Db1': 25,
  C1: 24,
  B0: 23,
  'A#0/Bb0': 22,
  A0: 21,
  'G#': 20,
  G: 19,
  'F#': 18,
  F: 17,
  E: 16,
  'D#': 15,
  D: 14,
  'C#': 13,
  C0: 12,
  B: 11,
  'A#': 10,
  A: 9,
  // "G#": 8,
  // "G": 7,
  // "F#": 6,
  // "F": 5,
  // "E": 4,
  // "D#": 3,
  // "D": 2,
  // "C#": 1,
  'C-1': 0,
}
